export default __webpack_public_path__ + "static/media/October2022.25f0b87f.png";